import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import { useLink, useSiteQuery } from '../../../hooks'
import MobileHeader from '../MobileHeader/MobileHeader'
import * as styles from "./header.module.scss"
import { useLocation } from '@reach/router'

const Header = () => {
    const { headerLogo, tempHeaderItems, headerButton } = useSiteQuery()

    const scrollTo = (id) => {
        window.scrollTo({
            top: document.getElementById(`${id}`)?.offsetTop - 80,
            behavior: "smooth",
        })
    }

    const [homeLocation, setHomeLocation] = useState(false)

    const { pathname, hash } = useLocation()
    useEffect(() => {
        if (pathname === '/') setHomeLocation(true)
        else setHomeLocation(false)
    }, [pathname])

    // useEffect(() => {
    //     console.log("hash", hash);

    //     if (hash) {
    //         scrollTo(hash.split('#')[1])
    //     }
    // }, [])

    return (
        <header>
            <div className={`${styles.container} ${styles.mainContainer}`}>
                <div className={`container-xl ${styles.headerContainer}`}>
                    {
                        homeLocation
                            ? <a onClick={e => scrollTo('home-content')} className={styles.headerLink}>
                                <div className={styles.headerLogo}>
                                    <GatsbyImage
                                        objectFit="contain"
                                        image={headerLogo.gatsbyImageData}
                                        alt={headerLogo.title}
                                    />
                                </div>
                            </a>
                            : <Link to={`/`} className={styles.headerLink}>
                                <div className={styles.headerLogo}>
                                    <GatsbyImage
                                        objectFit="contain"
                                        image={headerLogo.gatsbyImageData}
                                        alt={headerLogo.title}
                                    />
                                </div>
                            </Link>
                    }
                    <div className={styles.headerMenuGroup}>
                        {tempHeaderItems.map((item, index) => {
                            switch (item.__typename) {
                                case "ContentfulComponentLink":
                                    return item.slug && item.slug.includes('#') && homeLocation
                                        ? <li key={index} className={styles.headerMenu} onClick={e => scrollTo(item.slug.replace('#', ''))}>
                                            <a className={styles.headerLink}>{item.title}</a>
                                        </li>
                                        : <li key={index} className={styles.headerMenu}>
                                            <Link to={`/${useLink(item.target?.slug || item.slug)}`} className={styles.headerLink}>{item.title}</Link>
                                        </li>

                                // case "ContentfulComponentLinkGroup":
                                //     return (
                                //         <SideMenu key={index} data={item} index={index} />
                                //     )
                            }
                        })}
                    </div>
                    <div>
                        <button type="button" className={styles.headerBtn}>
                            {
                                headerButton.slug && headerButton.slug.includes('#') && homeLocation
                                    ? <a onClick={e => scrollTo(headerButton.slug.replace('#', ''))} className={styles.headerLink}>{headerButton.title}</a>
                                    : <Link to={`/${useLink(headerButton.target?.slug || headerButton.slug)}`} className={styles.headerLink}>
                                        {headerButton.title}
                                    </Link>
                            }
                        </button>
                    </div>
                </div>
            </div>
            <MobileHeader
                logo={headerLogo}
                items={tempHeaderItems}
            />
        </header>
    )
}

export default Header